const ACRONYMS = new Set(['ai', 'api', 'crm', 'csv', 'id', 'mcp', 'pdf', 'sms', 'url', 'uuid'])

/** `list_orders` / `GMAIL__SEND_EMAIL` → "List Orders" / "Send Email". */
export const actionTitle = (actionName: string) =>
  (actionName.split('__').pop() ?? actionName)
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((word) => {
      const lower = word.toLowerCase()
      return ACRONYMS.has(lower) ? lower.toUpperCase() : lower[0].toUpperCase() + lower.slice(1)
    })
    .join(' ')
